module.exports = __webpack_public_path__ + "img/arthurians-barbarian.0f265236.png";